import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Service } from '../../../models/service';
import { ServiceCategory } from '../../../models/service-category';
import { forkJoin } from 'rxjs';
import { EregistrationsTranslationService } from '../../../services/eregistrations-translation.service';
import { LOCAL_STORAGE_KEYS } from '../../../constants/storage-keys';

@Component({
  selector: 'app-service-list',
  templateUrl: './service-list.component.html'
})
export class ServiceListComponent implements OnInit {
  services: Service[] = [];
  allServices: Service[] = [];
  serviceCategories: ServiceCategory[] = [];
  currentServiceCategories: ServiceCategory[] = [];
  filterServicesSearch: string = '';

  @ViewChild('serviceFilters') serviceFilters!: ElementRef<HTMLElement>;
  @ViewChild('serviceItems') serviceItems!: ElementRef<HTMLDivElement>;

  constructor(
    private readonly http: HttpClient,
    public eregistrationsTranslationService: EregistrationsTranslationService
  ) {}

  ngOnInit(): void {
    const extraQuery = new URLSearchParams();
    extraQuery.set('lang', this.eregistrationsTranslationService.language);
    forkJoin({
      services: this.http.get<Service[]>(
        `${environment.BASE_API_URL}services?` + extraQuery.toString()
      ),
      serviceCategories: this.http.get<ServiceCategory[]>(
        `${environment.BASE_API_URL}services/categories?` +
          extraQuery.toString()
      )
    }).subscribe(({ services, serviceCategories }) => {
      this.allServices = services;
      this.services = services;
      this.serviceCategories = serviceCategories;
      [this.serviceItems, this.serviceFilters].forEach((el) => {
        if (el?.nativeElement) {
          el.nativeElement.classList.remove('placeholder');
        }
      });
    });
    const currentServiceCategories = localStorage.getItem(
      LOCAL_STORAGE_KEYS.CURRENT_SERVICE_CATEGORIES
    );
    if (typeof currentServiceCategories === 'string') {
      this.currentServiceCategories = JSON.parse(currentServiceCategories);
    }
  }

  isCategoryActive(catId: string): boolean {
    return this.currentServiceCategories.some(function (category) {
      return category.category_id === catId;
    });
  }

  toggleServiceCategory(
    category: ServiceCategory | undefined = undefined
  ): void {
    let index = -1;
    if (!category) {
      this.currentServiceCategories = [];
      localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_SERVICE_CATEGORIES);
      this.filterServices();
      return;
    }
    this.currentServiceCategories.some((cat, i) => {
      if (cat.category_id === category.category_id) {
        index = i;
        return true;
      }

      return null;
    });
    if (index === -1) {
      this.currentServiceCategories.push(category);
    } else {
      this.currentServiceCategories.splice(index, 1);
    }
    if (this.currentServiceCategories?.length) {
      localStorage.setItem(
        LOCAL_STORAGE_KEYS.CURRENT_SERVICE_CATEGORIES,
        JSON.stringify(this.currentServiceCategories)
      );
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.CURRENT_SERVICE_CATEGORIES);
    }
    this.filterServices();
  }

  filterServices() {
    let services = [];

    if (!this.currentServiceCategories?.length) {
      services = this.allServices.map(function (s) {
        return s;
      });
    } else {
      services = this.allServices.filter((s) => {
        return this.currentServiceCategories.some((c) => {
          return c.services.some(function (service) {
            return service.service_id === s.service_id;
          });
        });
      });
    }
    if (this.filterServicesSearch) {
      services = services.filter((s) => {
        return s.name
          .toLocaleLowerCase()
          .includes(this.filterServicesSearch.toLocaleLowerCase());
      });
    }
    this.services = services;
  }
}
